import React, { useState, useEffect } from "react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../utils/builder";
import { reportError } from "@/helpers/errorHelper";
import { removeTargetAttr } from "@/helpers/generalHelper";

const ContentTilePDP = ({ builderTargetingData }) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  useEffect(() => {
        let some = builderClient
          .get("content-tile-pdp", {
            userAttributes: {
              ...builderTargetingData
            },
          })
          .promise()
          .then((data) => {
            setBuilderContentJson(data);
            if(typeof data == 'undefined'){
              reportError('content-tile-pdp builder module not found')
            }
          });

    if (builderContentJson) {
      removeTargetAttr();
    }
    
  }, [builderTargetingData]);

  return (
    <BuilderComponent model="content-tile-pdp" content={builderContentJson} />
  );
};

export default ContentTilePDP;
